import { Link } from 'react-router-dom';
import { useLoad } from '../hooks/useLoad';
import { useService } from '../hooks/useService';

/** 회기 진행 (탭바 가운데): 내담자 고르기. 끝나지 않은 회기가 있으면 이어서, 없으면 새 회기 */
export function RunPickScreen() {
  const svc = useService();
  const { data } = useLoad(async () => {
    const [cards, home] = await Promise.all([svc.clientCards(), svc.home()]);
    return { cards: cards.filter((c) => c.status !== 'terminated'), pending: home.pending };
  }, [svc]);
  return (
    <section className="stack">
      <div>
        <p className="eyebrow">회기 진행</p>
        <h1 className="page-title">어느 내담자인가요?</h1>
      </div>
      {!data && <p className="muted">불러오는 중…</p>}
      {data && data.cards.length === 0 && (
        <p className="muted">
          진행 중인 내담자가 없습니다. <Link to="/clients">내담자 등록</Link>
        </p>
      )}
      <div className="list-card">
        {data?.cards.map((c) => {
          const open = data.pending.find((p) => p.clientId === c.clientId);
          return (
            <Link
              key={c.clientId}
              className="list-item"
              to={open ? `/sessions/${open.sessionId}/run` : `/clients/${c.clientId}/run`}
            >
              <span className="li-icon">{c.clientCode.slice(0, 2)}</span>
              <span className="li-main">
                <span className="li-title">{c.clientCode}</span>
                <span className="li-sub">
                  {open
                    ? `${open.sessionNumber}회기 이어서 · ${open.stage}`
                    : `${c.sessionCount}회기까지 · 새 회기 시작`}
                </span>
              </span>
              <span className="li-go">{open ? '이어서 →' : '시작 →'}</span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
